import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { PipesModule } from '../../pipes/pipes.module';

import { DirectivesModule } from '../../directives/directives.module';

import { VendorItemComponent } from './vendor-item.component';

import { RouterLinkComponentModule } from '../router-link/router-link.module';

@NgModule({
  declarations: [VendorItemComponent],
  imports: [CommonModule, IonicModule, PipesModule, DirectivesModule, RouterLinkComponentModule, TranslateModule.forChild()],
  exports: [VendorItemComponent],
})
export class VendorItemComponentModule {}
